import React, { memo } from 'react';
import Box from '@mui/material/Box';
import { partnerInitials } from './jobModel';

const PartnerAvatar: React.FC<{ name: string; variant?: 'default' | 'inverse' }> = ({ name, variant = 'default' }) => (
  <Box
    component="span"
    aria-hidden
    sx={{
      width: 32,
      height: 32,
      flexShrink: 0,
      borderRadius: '10px',
      bgcolor: variant === 'inverse' ? 'background.paper' : 'action.hover',
      color: 'text.secondary',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 12,
      fontWeight: 600,
    }}
  >
    {partnerInitials(name)}
  </Box>
);

export default memo(PartnerAvatar);
